import SearchRoadRoutingRequest, {
  SearchRoadRoutingRequestWaypointCoordinate,
} from "../../../utils/search-road-route/search-road-routing.request";
import PlanEntryRoadRouteParams, {
  PlanEntryRoadRouteParamsWaypoint,
} from "./plan-entry-road-route-params";

const createWaypointCoordinate = (
  type: PlanEntryRoadRouteParamsWaypoint,
): SearchRoadRoutingRequestWaypointCoordinate => {
  return {
    latitude: type.lat,
    longitude: type.lon,
  };
};

const create = (
  loadParams: PlanEntryRoadRouteParams,
): SearchRoadRoutingRequest => {
  return {
    waypointCoordinates: loadParams.waypoints.map(createWaypointCoordinate),
    excludeHighway: loadParams.excludeHighway,
  };
};

const planEntryRoadRouteParamsFactory = {
  create,
};

export default planEntryRoadRouteParamsFactory;
